module.exports = __webpack_public_path__ + "static/media/nik_publication_image_1.3106b5ed.png";